import * as React from "react";

export const Document = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.83333 4.71875C8.83333 5.10156 9.09375 5.375 9.45833 5.375H13V14.3438C13 14.7266 12.7135 15 12.375 15H3.625C3.26042 15 3 14.7266 3 14.3438V1.65625C3 1.30078 3.26042 1 3.625 1H8.83333V4.71875ZM13 4.33594V4.5H9.66667V1H9.82292C9.97917 1 10.1354 1.08203 10.2656 1.19141L12.8177 3.87109C12.9219 4.00781 13 4.17188 13 4.33594Z"
    />
);
